import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Angular4PaystackModule } from 'angular4-paystack';
import { NgxElectronModule } from 'ngx-electron';
import { NgxPaginationModule } from 'ngx-pagination';
//import { TooltipsModule } from 'ionic4-tooltips';
import { AngularFileViewerModule } from '@taldor-ltd/angular-file-viewer';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { NgxBarcodeModule } from 'ngx-barcode';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { TagInputModule } from 'ngx-chips';
import { NgxStripeModule } from 'ngx-stripe';
import { TimeagoModule } from 'ngx-timeago';
import { SplitViewModule } from 'ngx-split-view';
import { DataTableModule } from 'angular2-datatable';
import { ColorPickerModule } from 'ngx-color-picker';
import { FullCalendarModule } from '@fullcalendar/angular';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgFileDragDropModule } from 'ng-file-drag-drop';
import { WebcamModule } from 'ngx-webcam';
import { CountdownModule } from 'ngx-countdown';
import { UserPagesComponent } from './components/user-pages/user-pages';
import { HeaderButtonsComponent } from './components/header-buttons/header-buttons';
import { EmptyPageComponent } from './components/empty-page/empty-page'; //shown when there is no content in a page or component
import { EmojiPickerComponent } from './components/emoji-picker/emoji-picker'; // for chat messaging page
import { SafePipe } from './app.component';
import { RelativeTime } from './pipes/relative-time';
import { DaysPipe } from './pipes/days';
import { Translation } from './pipes/translation';
import { DifferentiateModule } from '@sedeh/differentiate';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FaIcon } from './pipes/fa-icon';
import { CommentPageComponent } from './components/comment/comment';
@NgModule({
  declarations: [EmojiPickerComponent, UserPagesComponent, HeaderButtonsComponent, EmptyPageComponent, CommentPageComponent, SafePipe, RelativeTime, DaysPipe, Translation, FaIcon],
  imports: [IonicModule],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxElectronModule,
    NguiAutoCompleteModule,
    //NgxStripeModule.forRoot('pk_live_r4YrMdde7YVDNKOnXS4b42f7'),
    EditorModule,
    NgxQRCodeModule,
    NgxBarcodeModule,
    DataTableModule,
    SplitViewModule,
    Angular4PaystackModule,
    //TooltipsModule,
    NgxPaginationModule,
    TimeagoModule,
    ColorPickerModule,
    FullCalendarModule,
    AngularFileViewerModule,
    NgFileDragDropModule,
    WebcamModule,
    CountdownModule,
    TagInputModule,
    EmojiPickerComponent,
    UserPagesComponent,
    HeaderButtonsComponent,
    EmptyPageComponent,
    CommentPageComponent,
    NgxBarcodeModule,
    DataTableModule,
    SafePipe,
    RelativeTime,
    DaysPipe,
    Translation,
    FaIcon,
    DifferentiateModule,
    FontAwesomeModule,
  ],
  entryComponents: [],
})
export class ComponentsModule {}
